import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';

export interface IPriceResultProps {
  price: string;
  priceDescription: string;
  priceRange: string;
  priceRangeDescription: string;
}

export const PriceResult: React.FC<IPriceResultProps> = ({
  price,
  priceDescription,
  priceRange,
  priceRangeDescription,
}) => {
  return (
    <>
      <div data-testid="PriceResult" className={styles['price']}>
        <ArticleHeading1 color="text-inverted-default">{price}</ArticleHeading1>
        <ArticleParagraph1 color="text-inverted-default">{priceDescription}</ArticleParagraph1>
      </div>
      <div>
        <ArticleHeading1 color="text-inverted-default">{priceRange}</ArticleHeading1>
        <ArticleParagraph1 color="text-inverted-default">{priceRangeDescription}</ArticleParagraph1>
      </div>
    </>
  );
};

PriceResult.displayName = 'PriceResult';
